import client from '@common/utils/rest';

export const getQuestionnaires = async ({ includeFamilyQuestionnaires, includeFhq4Questionnaires }) => {
  return client({
    path: 'api/questionnaire/getQuestionnaires',
    params: {
      includeFamilyQuestionnaires,
      includeFhq4Questionnaires,
    },
    method: 'GET'
  }).then(
    (response) => {
      return response.entity;
    },
  );
};

export const launchNewIndividualQuestionnaire = (globalId, questionnaireId, isFHQ4) => {
  return client({
    params: {
      globalId,
      questionnaireId,
      isFHQ4,
    },
    path: 'api/questionnaire/launchNewIndividualQuestionnaire',
    method: 'POST',
  }).then((response) => {
    return response.entity;
  });
}

export const getQuestionnaireForInvite = async ( inviteId ) => {
  return client({
    path: 'api/questionnaire/loadQuestionnaireForInvite',
    params: {
      inviteId,
    },
    method: 'GET'
  }).then(
      (response) => {
        return response.entity.data;
      },
  );
};